import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const fileUpload = async (
  url: string,
  isDropbox: boolean,
  file?: File,
  extraHeaders?: Record<string, string>,
): APIResponsePromise<any> => {
  try {
    const headers: any = isDropbox
      ? {
          'Content-Type': 'application/octet-stream',
        }
      : {
          'Content-Type': file?.type,
          Accept: 'application/json',
        };

    const response = await fetch(url, {
      headers: { ...(headers || {}), ...(extraHeaders || {}) },
      body: file,
      method: isDropbox ? 'POST' : 'PUT',
    });

    return response.blob();
  } catch (error) {
    console.error(error);
  }
};

export const processDocument = async ({
  companyId,
  description,
  documentName = '',
  documentType,
  id,
  markedAsOthers,
  path,
  questionnaireId,
  requiresSplitting,
  selectedOptions,
  shouldSkipMatching,
  tags,
  token,
}: APIRequest<{
  companyId: number;
  description: string;
  documentName: string;
  documentType?: string;
  id: string;
  markedAsOthers?: boolean;
  path: string;
  questionnaireId?: number;
  requiresSplitting?: boolean;
  selectedOptions?: Array<string>;
  shouldSkipMatching?: boolean;
  tags?: Array<string>;
}>): APIResponsePromise<{ is_duplicate: boolean; document_name: string }> => {
  if (path === '/') path = '';

  return await _callBackend(
    '/integrations/process_document',
    'POST',
    {
      company_id: companyId,
      description,
      document_name: documentName,
      document_type: documentType,
      id,
      marked_as_others: markedAsOthers,
      path,
      questionnaire_id: questionnaireId,
      requires_splitting: requiresSplitting,
      selected_options: selectedOptions,
      should_skip_matching: shouldSkipMatching,
      tags,
    },
    token,
  );
};

export const processDocumentWithToken = async ({
  documentName = '',
  id,
  path,
  questionnaireId,
  shouldSkipMatching,
  token,
}: APIRequest<{
  documentName: string;
  id: string;
  path: string;
  questionnaireId: number;
  shouldSkipMatching?: boolean;
}>): APIResponsePromise => {
  if (path === '/') path = '';

  return await _callBackend('/document_drop_off/process_document', 'POST', {
    document_name: documentName,
    document_type: 'dropped_off_document',
    id,
    path,
    questionnaire_id: questionnaireId,
    should_skip_matching: shouldSkipMatching,
    token,
  });
};
